import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { logList } from 'utils/requestUtil'

type TableLogState = {
  logList: logList[]
  allCount: number
  searchLoading: boolean
}

const initialState: TableLogState = {
  logList: [],
  allCount: 0,
  searchLoading: false,
}
export const TableLogSlice = createSlice({
  name: 'TableLog',
  initialState: initialState,
  reducers: {
    // 検索中フラグを変更する処理 //===========================//
    changeSearchLogding: (state, action: PayloadAction<boolean>) => {
      state.searchLoading = action.payload
    },
    // 表示ページ外のデータも含めた件数を変更する処理 //===========================//
    changeAllCount: (state, action: PayloadAction<number>) => {
      state.allCount = action.payload
    },
    // ログリストを変更する処理 //===========================//
    changeLogList: (state, action: PayloadAction<logList[]>) => {
      state.logList = action.payload
    },
    // すべて初期化する処理
    format: (state) => {
      for (const key in state) {
        const tempKey: keyof TableLogState = key as keyof TableLogState
        ;(state as any)[tempKey] = initialState[tempKey]
      }
    },
  },
})

// actionCreator 書き忘れないこと！
export const {
  changeSearchLogding, // 検索中フラグを変更する処理
  changeAllCount, // 表示ページ外のデータも含めた件数を変更する処理
  changeLogList, // ログリストを変更する処理
  format, // すべて初期化する処理
} = TableLogSlice.actions
export default TableLogSlice.reducer
